/* eslint react/require-default-props: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import styles from './index.styl';

const Icon = ({ name, size, height = 16, width = 16, ...other }) => {
  // hack for cases when icon shoud be dynamic
  // e.g. chat tabs icons
  const useTag = `<use xlink:href="#icon-${name}" />`;

  return (
    <svg
      height={size || height}
      styleName="root"
      width={size || width}
      {...other}
      dangerouslySetInnerHTML={{ __html: useTag }}
      focusable="false"
    />
  );
};

Icon.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  name: PropTypes.string,
  size: PropTypes.number,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default CSSModules(Icon, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/Icon/index.jsx